module.exports = __webpack_public_path__ + "img/nkudelko2.a50abe7b.jpg";